/*eslint no-unused-vars: "warn"*/
/*eslint react/prop-types: "warn"*/

import React, { useState } from 'react';

import {
    Card,
    Input,
    Button,
    Typography,
    IconButton,
    Textarea,
    List,
    ListItem,
    ListItemPrefix,
    ListItemSuffix,
    Avatar,
    Tooltip,
    Chip,

} from "@material-tailwind/react";



import { } from "@heroicons/react/24/outline";

import { ExclamationTriangleIcon, XMarkIcon, UserIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import { showAlert } from './Alert.jsx';
import { sendEmail } from './SendEmail';

import agro_avatar from "./agro_avatar.png"
import user_avatar from "./user_avatar.png"
import { filter } from 'jszip';

export default function ChatCard(props) {

    const [authenticated, setAuthenticated] = useState(localStorage.getItem("authenticated") || false);
    const [session, setSession] = useState(localStorage.getItem("session") || null);
    const [rank] = useState(localStorage.getItem("rank") || 0);
    const [clients, setClients] = useState(JSON.parse(localStorage.getItem("clients")) || []);
    const [messages, setMessages] = useState(JSON.parse(localStorage.getItem("messages")) || []); //from all users
    const [username] = useState(localStorage.getItem("username"));

    const [userId, setUserId] = useState(props.clientid || 0);
    const [message, setMessage] = useState(props.message);
    const [subject, setSubject] = useState(props.subject);

    const [chat,setChat] = useState(props.chat || []);
    const [conversation, setConversation] = useState([]);
    
    const [mySide, setMySide] = useState(props.side || "user");
    const [sendDisabled, setSendDisabled] = useState(false);
    const [search] = useState("");
    const [chatId, setChatId] = useState(0);

    React.useEffect(() => {
        console.log("START");
        console.log(props);

        //addEventListener('previewImageChanged', previewImageChanged);
        if (rank > 4) {
            console.log("changing rank");
            setMySide("admin");
            if (clients.length == 0) getClients(); //getClients if needed }
            if (chat.length==0) { getChat(); } 
        }
        if (chat.length==1) //this is for user
            setConversation(JSON.parse(chat[0].content));

        return () => {
            //removeEventListener('previewImageChanged', previewImageChanged);
            //console.log('removing listener');
        };

    }, []);


    function getClients() {
        var bodydata = JSON.stringify({ action: 'clients', session: session });

        fetch('https://online.mysoil.pl/cgi-bin/chat.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'

        })
            .then(res => res.json())
            .then(data => { setClients(JSON.parse(data.clients)); localStorage.setItem("clients", JSON.stringify(data.clients)); })
    }


    function getChat() {
        var bodydata = JSON.stringify({ action: 'list', session: session });
        console.log(bodydata);
        fetch('https://online.mysoil.pl/cgi-bin/chat.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'

        })
            .then(res => res.json())
            .then(data => { console.log("data"); console.log(data); parseChat(data.chat); })
    }


    function countEntries(contentStr)
    {
      var content=JSON.parse(contentStr);
      var count=0;
      if (content.length>0)
      {
        var index=content.length-1;
        while (content[index--].side=="user") count+=1;
      }
      console.log("count " + count);
      return count;
    }


    function parseChat(chatdata)
    {
        console.log("chatdata");
        console.log(chatdata);
        var counter=0;
        if (chatdata.length>0)
        {
        chatdata.forEach(entry => {
          if (entry.side=="user") 
            {
              entry.unread=countEntries(entry.content);
              counter+=entry.unread;
            }
            else
            {
              entry.unread=0; //brak nowych wiadomości dla admina
            }

        })
        }
        //console.log('counter');
        //console.log(counter);
        //console.log('chatdata');
        //console.log(chatdata);

        setChat(chatdata);
    }


    function cancelClose() {
        props.close();
    }








    function selectClient(e) {
        const id = e.currentTarget.getAttribute("data-clientid");
        console.log("selected id " + id);
        setUserId(id);
        var userchat=chat.filter((entry) => entry.userid == id);
        if (userchat.length==1) { setConversation(JSON.parse(userchat[0].content)); }
            else setConversation([]); //no entries
    }


    function ClientItem(props) {
        let tip = "Wybierz klienta do kontekstu"
        let edittip = "Edytuj dane klienta"
        let filetip = "Pokaż pliki powiazane z klientem"
        let master = 0;
        let unread = props.unread || 0;
        let usercolor = "gray";
        let selected=false;
        if (props.unread > 0) usercolor = "red";

        

        if (userId == props.id) {
            selected=true;
            if (props.unread > 0) usercolor = "purple";
            else usercolor = "blue";
        }

        let unreadArray=chat.filter((entry) => entry.userid==props.id);
        if (unreadArray.length==1) unread=unreadArray[0].unread;

        return (
            <div className='flex flex-row ml-0'>
                
                <ListItem className={(selected ? "border border-blue-500 bg-blue-50" : "border border-blue-50")} key={props.id} data-clientid={props.id} onClick={selectClient}>
                    <ListItemPrefix className='px-0 mr-2 ml-0'>
                        <UserIcon className='h-5 w-5 stroke-2' color={usercolor} />

                    </ListItemPrefix>
                    <Tooltip content={props.name}>
                        <span className='text-xs text-left line-clamp-2' color="blue">{props.name}</span>
                    </Tooltip>
                    <ListItemSuffix>
                        {unread > 0 &&
                            <Chip size="sm" variant="gradient" className="rounded-full align-center items-center text-sm text-white transition-all mr-0" color={"red"} value={unread} />
                        }
                    </ListItemSuffix>
                </ListItem>
            </div>
        )
    }





    function RenderClientList() {
        var select = [];
        var lsearch = search.toLowerCase();

        console.log("clients list render");
        if (search.length == 0 || search == '') { select = clients; }
        else if (search.length == 1) { select = clients.filter(c => c.name.toLowerCase().startsWith(lsearch)); }
        else { select = clients.filter(c => c.name.toLowerCase().includes(lsearch)); }

        if (Array.isArray(select)) {
            return (
                select.map((client) => (
                   
                    <ClientItem name={client.name} id={client.id} city={client.city} unread={0} />
                )
                ))
        }
    }



    function ChatWindow(props) {
        
        const [message, setMessage] = useState();
        const [chatItem, setChatItem] = useState({ message: "", date: "", side: "" })

        
        function handleDataResponse(data) {

            console.log(data);
            setSendDisabled(false); //tymczasowo odblokuj przycisk wyślij
            if (data.status === "ok") {
                showAlert("green", data.message, 4000);
                if (data.id) setChatId(data.id);
                var userchat=chat.filter((entry) => entry.userid == userId);     
                console.log("chat before update");
                console.log(chat);
                console.log("user chat before update");
                console.log(chat);

                if (userchat.length==1) 
                    {
                        userchat[0].content=JSON.stringify(conversation);
                        userchat[0].side=mySide;
                    }
                    else
                        {
                            //chat.push({ id:"new", userid:userId, side : conversation.side, content:JSON.stringify(conversation)})
                            chat.push({ id:"new", userid:userId, side : mySide, content:JSON.stringify(conversation)})
                        }  

                console.log("chat after update");
                console.log(chat);
                parseChat(chat);
            }
            if (data.status !== "ok") {
                showAlert("red", data.message, 4000);
            }
        }

        function handleConfirmResponse(data) {

            console.log(data);
            setSendDisabled(false); //tymczasowo odblokuj przycisk wyślij
            if (data.status === "ok") {
                showAlert("green", data.message, 4000);
                if (data.id) setChatId(data.id);
                var userchat=chat.filter((entry) => entry.userid == userId);     
                console.log("chat before update");
                console.log(chat);
                console.log("user chat before update");
                console.log(userchat);

                if (userchat.length==1) 
                    {
                        userchat[0].side="closed";
                    }

                console.log("chat after update");
                console.log(chat);
                parseChat([...chat]);
            }
            if (data.status !== "ok") {
                showAlert("red", data.message, 4000);
            }
        }





        function messageUpdate(e) {
            setMessage(e);
        }



        function handleSubmitChat(e) {
            e.preventDefault();
            setSendDisabled(true);


            var action = "create";
            var side = "user";
            //if (chatId > 0) action = "update";
            if (rank > 4) side = "admin";

            const date = new Date();
            var datestr = date.toLocaleTimeString()+ "  " + date.toLocaleDateString();
            chatItem.message= message;
            chatItem.date=datestr;
            chatItem.side=side;
            chatItem.username=username;
            //var convitem = { message: message, date: datestr, side: side };
            conversation.push(chatItem);

            var bodydata = JSON.stringify({ action: action, session: session, userid: userId, side: side, content: JSON.stringify(conversation)});
            console.log(bodydata);
            fetch('https://online.mysoil.pl/cgi-bin/chat.py', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: bodydata,
                mode: 'cors'
            })
                .then(res => res.json())
                .then(data => handleDataResponse(data))
                .catch(error => {
                    console.log({ errorMessage: error.toString() });
                    console.error('There was an error!', error);
                });

        }

        function handleConfirmChat(e) {
            e.preventDefault();


            var action = "close";

            const date = new Date();
            var datestr = date.toLocaleTimeString()+ "  " + date.toLocaleDateString();

            var bodydata = JSON.stringify({ action: action, session: session, userid: userId});
            console.log(bodydata);
            fetch('https://online.mysoil.pl/cgi-bin/chat.py', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: bodydata,
                mode: 'cors'
            })
                .then(res => res.json())
                .then(data => handleConfirmResponse(data))
                .catch(error => {
                    console.log({ errorMessage: error.toString() });
                    console.error('There was an error!', error);
                });
        }



        return (
            <div id="chatwindow" className="mb-2 flex flex-col w-full items-center justify-center bg-gray-100 px-2">

                <List className='w-full bg-gray-100 py-1 px-1 overflow-y-auto h-[50vh] self-start rounded-md border border-blue-200'>
                    {/*
                    <SingleChatLine index={1} side="admin" content="admin side text" date="20:13:23 12.01.2025" />
                    <SingleChatLine index={2} side="admin" content="second admin side text" />
                    <SingleChatLine index={3} side="user" content="user side text" />
                    */}
                    {conversation.map((conv,index) => (
                        <SingleChatLine index={index} side={conv.side} content={conv.message} date={conv.date} username={conv.username}/>
                    ))}

                </List>

                <div className="mx-auto my-2 p-0 w-full self-end">
                    <Textarea label="Wiadomość" className="m-0 p-0 w-full border border-blue-200 bg-white" value={message} onChange={e => messageUpdate(e.target.value)} />
                
                <div className="flex flex-row">
                <Button className="mx-auto items-center max-w-[8rem] mb-2 mt-4 justify-center text-[10px] bg-gradient-to-br from-cyan-500 to-cyan-300 p-1" disabled={sendDisabled} data-refresh={true} fullWidth type="submit" onClick={handleConfirmChat}>
                    Oznacz jako przeczytane
                </Button>

                <Button className="mx-auto items-center max-w-[8rem] mb-2 mt-4 justify-center bg-gradient-to-br from-teal-500 to-cyan-500 " disabled={sendDisabled} data-refresh={true} fullWidth type="submit" onClick={handleSubmitChat}>
                    Wyślij
                </Button>
                </div>    
                </div>
            </div>
        )


    }


    function SingleChatLine(props) {
        var content = props.content;
        var author = props.side;
        var date = props.date
        var username = props.username || "";
        var myavatar;
        var otheravatar;
        if (mySide == "admin") {
            myavatar = agro_avatar;
            otheravatar = user_avatar;
        }
        else {
            myavatar = user_avatar;
            otheravatar = agro_avatar;
        }
        if (username.length>1) username+= " napisał";

        return (

            <ListItem key={props.index} className='px-0 py-1 bg-gray-100'>
                <ListItemPrefix className='w-[4rem]  p-0 mx-1'>
                    {mySide == author &&
                        <Avatar size="md" color="light-green" className='m-0 p-1 border border-green-200 bg-white' src={myavatar}></Avatar>
                    }
                </ListItemPrefix>

                <div className='m-0 p-1 w-full text-xs bg-white min-h-[3rem] rounded-lg border border-blue-200'>
                    <label className='text-[11px] text-gray-400 p-0 m-0'>{date + " " + username}</label>
                    <Typography className="text-sm" >{content}</Typography>

                </div>

                <ListItemSuffix className='w-[4rem] p-0 mx-1'>
                    {mySide != author &&
                        <Avatar size="md" color="light-green" className='w-[4rem] p-1 border border-blue-200 bg-white' src={otheravatar}></Avatar>
                    }
                </ListItemSuffix>

            </ListItem>
        )
    }





    return (
        <div className='absolute w-full h-full top-0 left-0 items-center justify-cener m-auto z-[30] flex place-content-center bg-black/50 '>

            <Card color="white" className={"w-full mx-auto rounded-lg max-h-[70vh] overflow-y-none " + ((rank>4) ? 'max-w-[48rem]' : 'max-w-[32rem]')} shadow={false}>

                <div className="flex items-center justify-between gap-1 w-auto bg-gradient-to-br from-teal-500/75 to-cyan-500/75 pt-1 pb-1 rounded-t-lg">
                    <Typography color="white" variant="h6" className="mt-2 pl-12 font-normal mx-auto">
                        Agro-Technology Chat
                    </Typography>
                    <IconButton variant='text' className='right-2' color="white" data-refresh={false} onClick={cancelClose}>
                        <XMarkIcon className='w-6 h-6' />
                    </IconButton>

                </div>
                <div id="window" className="mb-2 flex flex-row w-full items-start justify-center bg-gray-100 p-1">
                    {rank > 4 &&
                        <div id="clientlist" className="mb-2 flex flex-col w-full max-w-[20rem] items-center justify-center bg-gray-100 overflow-y-auto">

                            <List className='w-full bg-white py-1 px-1 max-h-[70vh] overflow-y-auto'>
                                <RenderClientList />
                            </List>
                        </div>
                    }
                <ChatWindow />
                </div>
            </Card>

        </div>
    );
}

